/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";
import { getUsersList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import Header from "../../Header/Header";
import exportIcon from '../../../assets/icons/export_file_icon.svg';
import "./ActiveUsersList.scss";

const ActiveUsersList = ({ getUsersList, getStatisticsSuccess, usersList }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Set loading state and fetch active users list
    getStatisticsSuccess({ type: "usersList", loading: true });
    setCurrentPage(1); // Reset to page 1
    setIsLoading(true);
    
    const apiPayload = {
      name: "",
      email: "",
      country: "",
      city: "",
      os: "",
      langs: [],
      subscriptionTypes: [],
      enabledNotifications: [],
      phoneNumber: "",
      role: "",
      activeNow: true, // This is the key difference for active users
      page: 1,
      limit: 50,
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false)
    };
    
    getUsersList(apiPayload);
  }, []); // Only run on component mount

  const handleLoadMore = () => {
    console.log('handleLoadMore called, hasNextPage:', usersList?.hasNextPage, 'currentPage:', currentPage);
    if (usersList?.hasNextPage && !isLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsLoading(true);
      
      const apiPayload = {
        name: "",
        email: "",
        country: "",
        city: "",
        os: "",
        langs: [],
        subscriptionTypes: [],
        enabledNotifications: [],
        phoneNumber: "",
        role: "",
        activeNow: true, // Keep the active filter for pagination
        page: nextPage,
        limit: 50,
        onSuccess: () => {
          console.log('Load more success for page:', nextPage);
          setIsLoading(false);
        },
        onError: (error) => {
          console.log('Load more error for page:', nextPage, error);
          setIsLoading(false);
        }
      };
      
      getUsersList(apiPayload);
    }
  };

  const handleBackToDashboard = () => {
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div 
              className="close-icon" 
              onClick={handleBackToDashboard}
              title="Back to Dashboard"
            >
              ×
            </div>
            <div className="inner-title">ACTIVE USERS RIGHT NOW</div>
          </div>
          <div className="right-part">
            <div className="export-icon-container">
              <img 
                src={exportIcon} 
                alt="Export" 
                className="export-icon-styles"
              />
            </div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={{
              docs: usersList?.docs || [],
              totalPages: usersList?.totalPages || 0,
              page: usersList?.page || 1,
              totalDocs: usersList?.totalDocs || 0,
              hasNextPage: usersList?.hasNextPage || false
            }}
            preset="usersList"
            loading={usersList?.loading || isLoading}
            onLoadMore={handleLoadMore}
            emptyStateText="No active users found"
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  usersList: state.dashboard.usersList,
});

const mapDispatchToProps = (dispatch) => ({
  getUsersList: (payload) => dispatch(getUsersList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveUsersList);
